// extracted by mini-css-extract-plugin
export default {"wrapper":"wM-z","availablePromoMessagesLabel":"xM-z","promoMessageList":"yM-z","promoMessage":"zM-z","appliedPromoMessage":"AM-z","promoMessageAmount":"BM-z"};